import { render } from "./squaresGame.vue?vue&type=template&id=ba5395ea&scoped=true"
import script from "./squaresGame.vue?vue&type=script&lang=js"
export * from "./squaresGame.vue?vue&type=script&lang=js"

import "./squaresGame.vue?vue&type=style&index=0&id=ba5395ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba5395ea"]])

export default __exports__